
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ListItem',
  props: {
    icon: {
      type: String,
      default: undefined
    },
    label: {
      type: String,
      default: undefined
    },
    info: {
      type: String,
      default: undefined
    },
    to: {
      type: String,
      default: undefined
    }
  }
})
